// extracted by mini-css-extract-plugin
export default {"nav":"index_nav_plRto","logo":"index_logo_ou2jP","breadcrumbs":"index_breadcrumbs_lb2fF"};